import React from "react";

const GetReady = () => {
  return (
    <div className="medium-width">
      <p>
        Get Ready...
      </p>
    </div>
  )
}

export default GetReady;
